export const F = {
  NUMERO_DO_PEDIDO: "NUM. PEDIDO",
  NUMERO_DO_PROJETO: "NUM. PROJETO",
  CONSULTOR: "CONSULTOR",
  DATA_DA_VENDA: "DATA VENDA",
  OBRA_FUTURA: "OBRA FUTURA",
  LIBERACAO_DA_OBRA: "LIBERA\u00c7\u00c3O DA OBRA",
  DEFINICAO_ACABAMENTOS_REALIZADO: "DEFINI\u00c7\u00c3O ACABAMENTOS REALIZADO",
  DEFINICAO_ACABAMENTOS_LIMITE: "DEFINI\u00c7\u00c3O ACABAMENTOS LIMITE",
  MEDICAO_REALIZADO: "MEDI\u00c7\u00c3O REALIZADO",
  MEDICAO_LIMITE: "MEDI\u00c7\u00c3O LIMITE",
  EXECUTIVO_REALIZADO: "EXECUTIVO REALIZADO",
  EXECUTIVO_LIMITE: "EXECUTIVO LIMITE",
  APROVACAO_LIMITE: "APROVA\u00c7\u00c3O LIMITE",
  APROVACAO_DO_EXECUTIVO: "APROVA\u00c7\u00c3O DO EXECUTIVO",
  OTIMIZACAO_DO_LOTE: "OTIMIZA\u00c7\u00c3O DO LOTE",
  PRAZO_EM_DIAS: "PRAZO EM DIAS",
  NOME_DO_CLIENTE: "NOME DO CLIENTE",
  AMBIENTE: "AMBIENTE",
  VALOR_DO_AMBIENTE: "VALOR DO AMBIENTE",
  ENTREGA_PREVISTA: "ENTREGA PREVISTA",
  DATA_REPROGRAMADA: "DATA REPROGRAMADA",
  INICIO_DO_BLOQUEIO: "IN\u00cdCIO DO BLOQUEIO",
  FINAL_DO_BLOQUEIO: "FINAL DO BLOQUEIO",
  REVISAO: "REVIS\u00c3O",
  NUMERO_DO_LOTE: "N\u00daMERO DO LOTE",
  USINAGEM_UN: "USINAGEM UN",
  CAIXARIA_UN: "CAIXARIA UN",
  TAMBURATO: "TAMBURATO",
  RIPADO: "RIPADO",
  PORTAS_PUXADORES: "PORTAS PUXADORES",
  FERRAGENS_ESPECIAIS_QTD: "FERRAGENS ESPECIAIS",
  FERRAGENS_ESPECIAIS_DESCRITIVO: "DESCRITIVO FERRAGENS",
  // Quantidade + descritivo dos demais itens de terceiros (colunas AL-AU).
  // Coluna *_TERCEIROS (BI-BM) continua sendo usada como marcador de status
  // (X quando entregue) — aqui guardamos qty/descricao para apresentar.
  SERRALHERIA_QTD: "SERRALHERIA QTD",
  SERRALHERIA_DESCRITIVO: "SERRALHERIA DESCRITIVO",
  PERFIL_ALUMINIO_QTD: "PERFIL ALUMINIO QTD",
  PERFIL_ALUMINIO_DESCRITIVO: "PERFIL ALUMINIO DESCRITIVO",
  PORTAS_FRENTES_QTD: "PORTAS FRENTES QTD",
  PORTAS_FRENTES_DESCRITIVO: "PORTAS FRENTES DESCRITIVO",
  VIDRACARIA_QTD: "VIDRACARIA QTD",
  VIDRACARIA_DESCRITIVO: "VIDRACARIA DESCRITIVO",
  TAPECARIA_QTD: "TAPECARIA QTD",
  TAPECARIA_DESCRITIVO: "TAPECARIA DESCRITIVO",
  // Planejamento de acabamento (AJ/AK). Verniz com enfolhamento e feito por
  // terceiro — entra na fila de Terceiros; o status fica em CB (VERNIZ_ACAB).
  VERNIZ_QTD: "VERNIZ QTD",
  ACABAMENTO_DESCRITIVO: "DESCRITIVO ACABAMENTO",
  // Apontamentos por lote: a ETIQUETA (T), a coluna de ordem de compra (AX) e
  // o limite de fornecimento (BA) que as abas APONTAMENTO da planilha imprimem;
  // LACA (AI); verniz (AJ) e o descritivo único dos dois (AK) já existem
  // acima (VERNIZ_QTD, ACABAMENTO_DESCRITIVO). A célula de
  // ferragens especiais (AV) é lida também como texto porque o "X" de "não
  // se aplica" se perde na leitura numérica de FERRAGENS_ESPECIAIS_QTD.
  ETIQUETA: "ETIQUETA",
  ORDEM_DE_COMPRA: "ORDEM DE COMPRA",
  LIMITE_FORNECIMENTO: "LIMITE FORNECIMENTO",
  LACA_QTD: "LACA QTD",
  FERRAGENS_ESPECIAIS_CELULA: "FERRAGENS ESPECIAIS CELULA",
  MDF_BORDO: "MDF BORDO",
  INSUMOS_FERRAGENS: "INSUMOS FERRAGENS",
  // Limite de fornecimento das compras (BA) - formula a partir da otimizacao do lote.
  FORNECIMENTO: "FORNECIMENTO",
  DATA_DE_CORTE: "DATA DE CORTE",
  DATA_DE_BORDO: "DATA DE BORDO",
  DATA_DE_FURACAO: "DATA DE FURA\u00c7\u00c3O",
  DATA_DE_USINAGEM: "DATA DE USINAGEM",
  FINAL_MAQUINAS: "FINAL M\u00c1QUINAS",
  SERRALHERIA_TERCEIROS: "SERRALHERIA TERCEIROS",
  PERFIL_ALUMINIO_TERCEIROS: "PERFIL ALUMINIO TERCEIROS",
  PORTAS_FRENTES_TERCEIROS: "PORTAS FRENTES TERCEIROS",
  VIDRACARIA: "VIDRA\u00c7ARIA",
  TAPECARIA_TERCEIROS: "TAPE\u00c7ARIA TERCEIROS",
  FERRAGENS_ESPECIAIS_TERCEIROS: "FERRAGENS ESPECIAIS TERCEIROS",
  RECEBIMENTO_TERCEIROS: "RECEBIMENTO TERCEIROS",
  ENTREGA_TERCEIROS: "ENTREGA TERCEIROS",
  CAIXARIA_MARC: "CAIXARIA MARC",
  TAMBURATO_MARC: "TAMBURATO MARC",
  ACABAMENTO_MANUAL_PORTA: "ACABAMENTO MANUAL PORTA",
  RIPADO_MARC: "RIPADO MARC",
  FINAL_MARCENARIA: "FINAL MARCENARIA",
  MARCENEIRO_RESPONSAVEL: "MARCENEIRO RESPONS\u00c1VEL",
  MARCENARIA_INICIO: "MARCENARIA IN\u00cdCIO",
  MARCENARIA_TERMINO: "MARCENARIA T\u00c9RMINO",
  FINAL_MARCENARIA_REPROGRAMADO: "FINAL MARCENARIA REPROGRAMADO",
  STATUS_MARCENARIA: "STATUS MARCENARIA",
  PINTURA: "PINTURA",
  VERNIZ_ACAB: "VERNIZ ACAB",
  PINTURA_PERFIL: "PINTURA PERFIL",
  PINTURA_SERRALHERIA: "PINTURA SERRALHERIA",
  ACABAMENTO_REALIZADO: "ACABAMENTO REALIZADO",
  FINAL_ACABAMENTO: "FINAL ACABAMENTO",
  FINAL_ACABAMENTO_REPROGRAMADO: "FINAL ACABAMENTO REPROGRAMADO",
  LIMPEZA_EMBALAGEM: "LIMPEZA EMBALAGEM",
  SEPARACAO: "SEPARA\u00c7\u00c3O",
  EXPEDICAO: "EXPEDI\u00c7\u00c3O",
  EXPEDICAO_REPROGRAMADA: "EXPEDI\u00c7\u00c3O REPROGRAMADA",
  CARREGAMENTO: "CARREGAMENTO",
  ENTREGA_CLIENTE: "ENTREGA CLIENTE",
  VENDEDOR: "VENDEDOR",
  OBSERVACOES_GERAIS: "OBSERVA\u00c7\u00d5ES GERAIS",
  TIPO_AMBIENTE: "TIPO_AMBIENTE",
  MDF_M2: "MDF M2",
  PECAS_UN: "PE\u00c7AS UN",
  COMPLEXIDADE_M2: "COMPLEXIDADE M2",
  COMPLEXIDADE_PECAS: "COMPLEXIDADE PE\u00c7AS",
  COMPLEXIDADE_USINAGENS: "COMPLEXIDADE USINAGENS",
  COMPLEXIDADE_CAIXARIA: "COMPLEXIDADE CAIXARIA",
  COMPLEXIDADE_PORTAS_PUXADORES: "COMPLEXIDADE PORTAS PUXADORES",
  COMPLEXIDADE_TOTAL: "COMPLEXIDADE TOTAL",
};
